import { ACTIVE_PAGE, SHOW_MESSAGE, SHOW_LOADING } from '../actions/types';

const INITIAL_STATE = {
    activePage: 'products',
    loader: {
        message: 'Loading',
        active: false
    },
    message: {
        header: '',
        content: '',
        color: 'green',
        hidden: true
    },
    // loginSuccessHandle: null,
    // loading: false
}

export default (state = INITIAL_STATE, action) => {
    console.log(action);

    switch (action.type) {
        case ACTIVE_PAGE:
            return { ...state, activePage: action.payload }

        case SHOW_LOADING:
            return { ...state, loader: action.payload }

        case SHOW_MESSAGE:
            return { ...state, message: action.payload }

        default:
            return state;
    }
};